import { Type } from 'class-transformer';

export class BatchItemResultDto {
    sourceHeaderID: number;
    @Type(() => Date)
    postDate: Date;
    @Type(() => Date)
    docDate: Date;
    docNumber: string;
    description: string;
    vendorCustomerID: number;
    vendorCustomerCode: string;
    vendorCustomerName: string;
    source: string;
    sourceType: string;
    amount: number;
}
